(function () {
  const COOKIE_CHOICE = 'geo_redirect_choice';
  const COOKIE_CHECKED = 'is_geo_redirect_checked';
  const COOKIE_DAYS = 7;

  const GEO_REDIRECTS = [
    // Australia / NZ
    { country_code: 'AU', country_name: 'Australia', redirect_link: 'https://addictedtoaudio.com.au' },
    { country_code: 'NZ', country_name: 'New Zealand', redirect_link: 'https://addictedtoaudio.co.nz' },

    // Europe
    { country_code: 'FR', country_name: 'France', redirect_link: 'https://www.son-video.com/' },
    { country_code: 'PL', country_name: 'Poland', redirect_link: 'http://www.audioheaven.eu' },
    {
      country_code: 'GB',
      country_name: 'United Kingdom',
      redirect_link: 'https://www.electromod.co.uk/products/dekoni',
    },
    { country_code: 'RU', country_name: 'Russia', redirect_link: 'https://doctorhead.ru' },
    { country_code: 'DE', country_name: 'Germany', redirect_link: 'https://www.wodaudio.com' },
    { country_code: 'ES', country_name: 'Spain', redirect_link: 'https://www.zococity.es' },
    { country_code: 'PT', country_name: 'Portugal', redirect_link: 'https://www.zococity.es' }, // same dealer
    { country_code: 'SE', country_name: 'Sweden', redirect_link: 'https://www.hifiheads.se' },
    { country_code: 'NL', country_name: 'Netherlands', redirect_link: 'https://www.wifimedia.eu' },
    { country_code: 'FI', country_name: 'Finland', redirect_link: 'https://www.turpex.com' },
    { country_code: 'NO', country_name: 'Norway', redirect_link: 'https://duet.no' },

    // Asia
    { country_code: 'TW', country_name: 'Taiwan', redirect_link: 'https://www.audiolinked.com.tw' },
    { country_code: 'SG', country_name: 'Singapore', redirect_link: 'https://av1group.com.sg' }, // Eng Siang
    { country_code: 'JP', country_name: 'Japan', redirect_link: 'https://shop.miyaji.co.jp' },
    { country_code: 'IN', country_name: 'India', redirect_link: 'https://www.headphonezone.in' },
    { country_code: 'BD', country_name: 'Bangladesh', redirect_link: 'http://www.gearsforears.com' },
    { country_code: 'TH', country_name: 'Thailand', redirect_link: 'https://www.munkongadget.com' },
    { country_code: 'AE', country_name: 'United Arab Emirates', redirect_link: 'https://www.primeaudio.ae' },

    // South America
    { country_code: 'PE', country_name: 'Peru', redirect_link: 'https://www.audiolima.com' },

    // Fallback / Global
  ];

  console.log(GEO_REDIRECTS, 'GEO_REDIRECTS');

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1];
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
  }

  // ✅ STOP if API already checked
  if (getCookie(COOKIE_CHECKED)) return;

  // ✅ Mark API as checked immediately (important)
  setCookie(COOKIE_CHECKED, 'true', COOKIE_DAYS);

  fetch('https://get.geojs.io/v1/ip/geo.json')
    .then((res) => res.json())
    .then((data) => {
      if (!data || !data.country_code) return;

      const match = GEO_REDIRECTS.find((item) => item.country_code === data.country_code);

      if (!match || !match.redirect_link) return;

      // If user already accepted/declined before
      if (getCookie(COOKIE_CHOICE)) return;

      const modal = document.getElementById('geoModal');
      const text = document.getElementById('geoText');
      const accept = document.getElementById('geoAccept');
      const decline = document.getElementById('geoDecline');
      const closeBtn = document.getElementById('geoClose');

      if (!modal || !text || !accept || !decline || !closeBtn) return;

      text.innerHTML = `
        We noticed you are visiting from <strong>${match.country_name}</strong>.<br>
        Would you like to continue on our local website?
      `;

      setTimeout(() => {
        modal.style.display = 'flex';
      }, 5000);

      function closeModal(choice = 'declined') {
        setCookie(COOKIE_CHOICE, choice, COOKIE_DAYS);
        modal.style.display = 'none';
      }

      accept.onclick = function () {
        closeModal('accepted');
        window.open(match.redirect_link, '_blank');
      };

      decline.onclick = () => closeModal('declined');
      closeBtn.onclick = () => closeModal('declined');
    })
    .catch((err) => console.error('Geo lookup failed', err));
})();

